import './DFooter2.css';
import React,{useCallback,useState,useEffect} from "react";

// import tcblogo from '@/asstes/footer-tcb.png'
import tcblogo from '@/assets/footer-tcb.png';
import erweima from '@/assets/ctw.jpg';
import erweima2 from '@/assets/ctw2.jpg';








const DFooter2 = (props) => {


	

	const onSub = (event)=>{
        event.preventDefault()
    }

	return (
		<div className='footer2'>
			<form className="wrap" onSubmit={(e)=>onSub(e)}>
				<div className='center'>
					<div className='tcbbox'>
						<img src={tcblogo} alt="" />
					</div>
					<div className='formbox'>
						<div className='title'>友情链接</div>
						<div className='linkbox'>
							<a href='https://ceramicglobal100.com/' target="_blank" rel="noreferrer">世界陶瓷卫浴100强</a>
							<a href='https://www.uniceramics.com.cn' target="_blank" rel="noreferrer">佛山潭洲陶瓷展</a>
						</div>
					</div>
					<div className='erweima'>
						<div>
							<img src={erweima2} alt='' />
							<div className='title'>陶城报公众号</div>
						</div>
						<div>
							<img src={erweima} alt='' />
							<div className='title'>CTW 公众号</div>
						</div>
						
					</div>
				</div>
			</form>
		</div>
	);
};

export default DFooter2;